(function () {
  if (window.__sbacRelativeDatesBound) return;
  window.__sbacRelativeDatesBound = true;

  function formatRelativeDate(date) {
    var now = new Date();
    var diffMs = now.getTime() - date.getTime();
    var diffSec = Math.floor(diffMs / 1000);
    var diffMin = Math.floor(diffSec / 60);
    var diffHour = Math.floor(diffMin / 60);
    var diffDay = Math.floor(diffHour / 24);
    var diffMonth = Math.floor(diffDay / 30);
    var diffYear = Math.floor(diffDay / 365);

    if (diffSec < 60) return 'Just now';
    if (diffMin < 60) return diffMin + (diffMin === 1 ? ' minute ago' : ' minutes ago');
    if (diffHour < 24) return diffHour + (diffHour === 1 ? ' hour ago' : ' hours ago');
    if (diffDay < 30) return diffDay + (diffDay === 1 ? ' day ago' : ' days ago');
    if (diffMonth < 12) return diffMonth + (diffMonth === 1 ? ' month ago' : ' months ago');
    return diffYear + (diffYear === 1 ? ' year ago' : ' years ago');
  }

  function updateRelativeDates(root) {
    root.querySelectorAll('[data-sbac-relative-date]').forEach(function (el) {
      var iso = el.getAttribute('datetime');
      if (!iso) return;
      var date = new Date(iso);
      if (Number.isNaN(date.getTime())) return;
      el.textContent = formatRelativeDate(date);
    });
  }

  function boot() {
    document.querySelectorAll('.simpler-blog-article-comments').forEach(updateRelativeDates);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!root) return;
    updateRelativeDates(root);
  });
})();
